import React from "react"; // eslint-disable-line no-unused-vars
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import { connect } from "react-redux";

const ErrorModal = ({ isModalOpen, toggle, errorMessage }) => (
  <Modal
    className="patient-disclosure-popup-modal"
    isOpen={isModalOpen}
    backdrop
    keyboard={false}
    wrapClassName="modal-primary"
    size="lg"
  >
    <ModalBody>
      <div style={{ fontSize: "21px" }}>
        <b>Please Fix The Errors</b>
      </div>
      <div>
        <b
          dangerouslySetInnerHTML={{
            __html: errorMessage,
          }}
        ></b>
      </div>
      <div className="patient-disclosure-popup-button">
        <button
          type="button"
          onClick={toggle}
          className="btn btn-primary submit-button btn-rounded"
        >
          Ok
        </button>
      </div>
    </ModalBody>
  </Modal>
);

const mapStateToProps = (state) => ({
  pageContent: state.pageContent,
});

export default connect(mapStateToProps)(ErrorModal);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/TET/errorModal.js